import React, { Component } from 'react';
import AppOption from '../components/AppOption';
import * as Icons from '../Utilities/ImgConfig';
import { injectIntl } from 'react-intl';


class ApplicationList extends Component {

  render() {
    const { albumList, intl, allUserInfo } = this.props
    const isFree = allUserInfo?.currentSubscription?.plan ?.name == "FREE"

    return (
      <div className = 'listapps-container-options'>
        <div className="listapps-container-options-lists">
          <AppOption functClick={albumList} title={intl.formatMessage({id: 'APLICATION_LIST_TITLE_VITALBOOK'})} icon = {Icons.Llibre_1} text={intl.formatMessage({id: 'TEXT_VITALBOOK'})}/>
          <AppOption functClick={()=>this.navigation('vitalangels')} title={intl.formatMessage({id: 'APLICATION_LIST_TITLE_VITALANGEL'})} icon={Icons.Diamant_2} text={intl.formatMessage({id: 'TEXT_VITALANGEL'})}/>
          <AppOption functClick={()=>this.navigation('upload')} title={intl.formatMessage({id: 'APLICATION_LIST_TITLE_MSG_VID'})} icon={Icons.Missatges}  text={intl.formatMessage({id: isFree ? 'TEXT_MENSAJES_FREE' : 'TEXT_MENSAJES'})} isFree={isFree} isDisabled={isFree} />
        </div>
        <div className="listapps-container-options-lists">
          <AppOption functClick={()=>this.navigation('docs')} title={intl.formatMessage({id: 'APLICATION_LIST_TITLE_DOCS'})} icon={Icons.Arxius} text={intl.formatMessage({id: isFree ? 'TEXT_DOCUMENTOS_FREE' : 'TEXT_DOCUMENTOS'})} isFree={isFree} isDisabled={isFree} />
          <AppOption functClick={()=>this.navigation('familytree')} title={intl.formatMessage({id: 'APLICATION_LIST_TITLE_GENEALOGICAL'})} icon={Icons.Cercle} text={intl.formatMessage({id: 'TEXT_GENTREE'})} />
          {/* <AppOption functClick={this.goToFaqs} title={intl.formatMessage({id: 'APLICATION_LIST_TITLE_FAQS'})} icon={Icons.FAQS} text={intl.formatMessage({id: 'TEXT_FAQS'})} /> */}
          <AppOption functClick={()=>this.navigation('video')}title={intl.formatMessage({id: 'APLICATION_LIST_TITLE_PRINTER'})} icon={Icons.PhotoCamera}  text={intl.formatMessage({id: isFree ? 'TEXT_PRINTER_FREE' : 'TEXT_PRINTER'})} isFree={isFree} isDisabled={isFree}  />
        </div>
      </div>
    );
  }

  navigation = (direction) => {
    const { push } = this.props
    push(`/${direction}`, {idUser: this.props.allUserInfo.id})
  }
}

export default injectIntl(ApplicationList);